import { render, staticRenderFns } from "./ItemMap.vue?vue&type=template&id=12674894&scoped=true"
import script from "./ItemMap.vue?vue&type=script&lang=ts"
export * from "./ItemMap.vue?vue&type=script&lang=ts"
import style0 from "./ItemMap.vue?vue&type=style&index=0&id=12674894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12674894",
  null
  
)

export default component.exports